// extracted by mini-css-extract-plugin
export default {"devlinkPage":"Devlink_devlinkPage__7PKlR","notFoundPage":"Devlink_notFoundPage__ArGMW","notFoundCode":"Devlink_notFoundCode__-KPXP"};